import request from '@/utils/request'

// 获取所有标签
export function getAllTags() {
  return request({
    url: '/api/tags',
    method: 'get'
  })
}

// 创建新标签
export function createTag(data) {
  return request({
    url: '/api/tags',
    method: 'post',
    data
  })
}

// 更新标签
export function updateTag(tagCode, data) {
  return request({
    url: `/api/tags/${tagCode}`,
    method: 'put',
    data
  })
}

// 删除标签
export function deleteTag(tagCode) {
  return request({
    url: `/api/tags/${tagCode}`,
    method: 'delete'
  })
}

// 获取标签统计数据
export function getTagsStatistics(params) {
  return request({
    url: '/api/tags/statistics',
    method: 'get',
    params
  })
}

// 获取标签关联的题目数据
export function getTagQuestions(tagCode, params) {
  return request({
    url: `/api/tags/${tagCode}/questions`,
    method: 'get',
    params
  })
} 